export default {
  buttonSelect: {
    label: 'Selecionar'
  }
}
